import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Site} from '../../shared/models/site';

export const siteActionTypes = {
  LOAD: type('[site] Load'),
  LOAD_MULTI: type('[site Multi] Load'),
  LOAD_MULTI_ONE_SUBSCRIPTION: type('[site Multi one sub] Load'),
  LOAD_SUCCESS: type('[site] Load Success'),
  LOAD_SUCCESS_MULTI: type('[site Multi] Load Success'),
  LOAD_SUCCESS_MULTI_ONE_SUBSCRIPTION: type('[site Multi one sub] Load Success'),
  LOAD_FAIL: type('[site] Load Fail'),
  CLEAR: type('[site] Clear'),
};

export class LoadSiteAction implements Action {
  readonly type = siteActionTypes.LOAD;
  constructor(public payload?: string) {}
}
export class LoadSiteMultiAction implements Action {
  readonly type = siteActionTypes.LOAD_MULTI;
  constructor(public payload?: string) {
    // console.log('LoadSiteMultiAction')
  }
}
export class LoadSiteMultiOneSubscriptionAction implements Action {
  readonly type = siteActionTypes.LOAD_MULTI_ONE_SUBSCRIPTION;
  constructor(public payload?: string) {
    // console.log('LoadSiteMultiAction')
  }
}

export class LoadSiteSuccessAction implements Action {
  readonly type = siteActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Site) {}
}
export class LoadSiteMultiOneSubscriptionSuccessAction implements Action {
  readonly type = siteActionTypes.LOAD_SUCCESS_MULTI_ONE_SUBSCRIPTION;
  constructor(public payload?: Site) {}
}
export class LoadSiteMultiSuccessAction implements Action {
  readonly type = siteActionTypes.LOAD_SUCCESS_MULTI;
  constructor(public payload?: Site) {}
}
export class LoadSiteFailAction implements Action {
  readonly type = siteActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class SiteClearAction implements Action {
  readonly type = siteActionTypes.CLEAR;
  constructor() {}
}

